"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loyaltyWatechers = loyaltyWatechers;
var _effects = require("redux-saga/effects");
var _sagas = require("../../auth/login/redux/sagas");
var api = _interopRequireWildcard(require("../api/loyaltyApi"));
var actions = _interopRequireWildcard(require("./actions"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function* linkLoyalticsAccount(requestParam) {
  try {
    const {
      params
    } = requestParam.data;
    yield (0, _effects.put)(actions.GET_LINK_LOYALTY_ACCOUNT_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.linkLoyalticsAccountApi, params, tokenData);
    yield (0, _effects.put)(actions.GET_LINK_LOYALTY_ACCOUNT_API.success(mainResponse));
    requestParam.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_LINK_LOYALTY_ACCOUNT_API.failure(err));
    requestParam.data.onFailure(err);
  }
}
function* checkLoyalticsCustomerAPI(requestParam) {
  const {
    params
  } = requestParam.data;
  try {
    yield (0, _effects.put)(actions.GET_LOTALTY_CUSTOMER_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.checkLoyalticsCustomerAPI, params, tokenData);
    yield (0, _effects.put)(actions.GET_LOTALTY_CUSTOMER_API.success(mainResponse));
    requestParam.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_LOTALTY_CUSTOMER_API.failure(err));
    requestParam.data.onFailure(err);
  }
}
function* getRequestHelpAPI(requestParam) {
  const {
    params
  } = requestParam.data;
  try {
    yield (0, _effects.put)(actions.GET_REQUEST_HELP_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.requestSupportHelp, params, tokenData);
    yield (0, _effects.put)(actions.GET_REQUEST_HELP_API.success(mainResponse));
    requestParam.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_REQUEST_HELP_API.failure(err));
    requestParam.data.onFailure(err);
  }
}
function* getLoyaltyOffers(params) {
  try {
    yield (0, _effects.put)(actions.GET_LOYALTY_OFFERS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.loyaltyOffers, params, tokenData);
    yield (0, _effects.put)(actions.GET_LOYALTY_OFFERS_API.success(mainResponse));
    params.data.onSuccess(mainResponse);
    return mainResponse;
  } catch (err) {
    yield (0, _effects.put)(actions.GET_LOYALTY_OFFERS_API.failure(err));
    params.data.onFailure(err);
  }
}
function* getNewLoyaltics(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_NEW_LOYALTICS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getNewLoyaltics, requestParam, tokenData);
    yield (0, _effects.put)(actions.GET_NEW_LOYALTICS_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_NEW_LOYALTICS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getSecureQuestioner(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_SECURE_QUESTIONER_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getSecureQuestioner, requestParam, tokenData);
    yield (0, _effects.put)(actions.GET_SECURE_QUESTIONER_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_SECURE_QUESTIONER_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* getUserEligibility(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_USER_ELIGIBILITY_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.getUserEligibility, requestParam, tokenData);
    yield (0, _effects.put)(actions.GET_USER_ELIGIBILITY_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_USER_ELIGIBILITY_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* postSecureAnswers(params) {
  try {
    const {
      requestParam
    } = params.data;
    yield (0, _effects.put)(actions.GET_SECURE_ANSWERS_API.request());
    const tokenData = yield (0, _effects.call)(_sagas.authorizeRequest);
    const mainResponse = yield (0, _effects.call)(api.postSecureAnswers, requestParam, tokenData);
    yield (0, _effects.put)(actions.GET_SECURE_ANSWERS_API.success(mainResponse));
    if (params.data && params.data.onSuccess) {
      params.data.onSuccess(mainResponse);
    }
  } catch (err) {
    yield (0, _effects.put)(actions.GET_SECURE_ANSWERS_API.failure(err));
    if (params.data && params.data.onFailure) {
      params.data.onFailure(err);
    }
  }
}
function* loyaltyWatechers() {
  yield (0, _effects.takeLatest)(actions.GET_LOTALTY_CUSTOMER, checkLoyalticsCustomerAPI);
  yield (0, _effects.takeLatest)(actions.GET_LINK_LOYALTY_ACCOUNT, linkLoyalticsAccount);
  yield (0, _effects.takeLatest)(actions.GET_REQUEST_HELP, getRequestHelpAPI);
  yield (0, _effects.takeLatest)(actions.GET_LOYALTY_OFFERS, getLoyaltyOffers);
  yield (0, _effects.takeLatest)(actions.GET_NEW_LOYALTICS, getNewLoyaltics);
  yield (0, _effects.takeLatest)(actions.GET_SECURE_QUESTIONER, getSecureQuestioner);
  yield (0, _effects.takeLatest)(actions.GET_USER_ELIGIBILITY, getUserEligibility);
  yield (0, _effects.takeLatest)(actions.GET_SECURE_ANSWERS, postSecureAnswers);
}